
import {
  defineComponent,
  toRefs,
  reactive,
  onMounted,
  computed,
  inject
} from "vue";
import { useOrgaoAetService } from "../../modules/business/common/commonBusiness";

interface OrgaoAetImgState {
  stateReady: boolean;
}

export default defineComponent({
  setup(props) {
    const state = reactive<OrgaoAetImgState>({
      stateReady: false
    });
    const staticAssetsUrl = inject("staticAssetsUrl");

    const orgaoStr = computed(() => {
      return useOrgaoAetService().getOrgaoAetStr(props.idOrgao);
    });

    const orgaoImagePath = computed(() => {
      const orgaoSigla = useOrgaoAetService().getOrgaoAetSigla(props.idOrgao);
      if (orgaoSigla) {
        return (
          "content: url(" +
          staticAssetsUrl +
          "/img/" +
          orgaoSigla.toLowerCase() +
          "/logo.png);"
        );
      }
      return "";
    });

    onMounted(async () => {
      state.stateReady = true;
    });

    return {
      orgaoStr,
      orgaoImagePath,
      ...toRefs(state)
    };
  },
  props: {
    idOrgao: {
      type: Number
    }
  }
});
